import styles from './PrimaryBriefingInputForm.module.css';
import Input from '../../../../Input/Input';
import {CustomSelect} from '../../../../Select/Select';
import {Textarea} from '../../../../textarea/Textarea';


export function PrimaryBriefingInputForm({
	optionsProf,
	selectedProfOption,
	handleProfessionChange,
	managerTitle,
	setManagerTitle,
	equipmentHint,
	setEquipmentHint
}) {
	return (
		<div className={styles.inputs}>
			<CustomSelect
				className={styles.my_wider_select}
				value={selectedProfOption}
				options={optionsProf}
				placeholder="Профессия"
				onChange={handleProfessionChange}
				width="100%"
			/>
			<Input
				placeholder="Должность непосредственного руководителя"
				value={managerTitle}
				onChange={(e) => setManagerTitle(e.target.value)}
			/>
			<Textarea
				placeholder="Оборудование"
				text={equipmentHint}
				setText={setEquipmentHint}
				className={styles.textarea_description}
			/>
		</div>
	);
}
